import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useLayoutEffect, useState } from 'react';
import Player from '@vimeo/player';
import { IFrameContainer } from './IFrameContainer';
const PlayerAPI = _ref => {
  let {
    player,
    playing,
    muted = false,
    onEnd,
    onPlay,
    onPause,
    onProgress
  } = _ref;
  useLayoutEffect(() => {
    player.setMuted(muted);
  }, [player, muted]);
  useLayoutEffect(() => {
    playing ? player.play() : player.pause();
  }, [player, playing]);
  useLayoutEffect(() => {
    onPlay && player.on('playing', onPlay);
    onPause && player.on('pause', onPause);
    onEnd && player.on('ended', onEnd);
  }, [player, onPlay, onPause, onEnd, onProgress]);
  return null;
};
export const Vimeo = props => {
  const {
    src,
    muted,
    onPlayerReady
  } = props;
  const [player, setPlayer] = useState();
  const setRef = useCallback(iframe => {
    if (iframe) {
      const vimeoPlayer = new Player(iframe, {
        muted,
        progress_bar: true,
        progressBar: true
      });
      onPlayerReady && onPlayerReady(vimeoPlayer);
      setPlayer(vimeoPlayer);
    }
  }, [muted]);
  return /*#__PURE__*/React.createElement(IFrameContainer, {
    poster: props.poster
  }, size => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("iframe", {
      ref: setRef,
      title: "Vimeo",
      src: src,
      frameBorder: "0",
      allowFullScreen: true,
      allow: "autoplay; encrypted-media",
      width: size.width,
      height: size.height
    }), player ? /*#__PURE__*/React.createElement(PlayerAPI, _extends({}, props, {
      player: player
    })) : null);
  });
};
//# sourceMappingURL=Vimeo.js.map